export * from './relatedEvents.component';
